import { Papeis, Papel, listaPapeis, PAPEIS_MEMBROS_ACUMULATIVO } from "service/restricao/Papeis";
import { MembroUnidadeDetalhado } from "model/reino/MembroUnidade";
import { PapelMembro } from "model/seguranca/PapelMembro";

export class Autorizacao {
  public readonly papeis: Papeis;
  public readonly membroUnidade: MembroUnidadeDetalhado|undefined;

  constructor(membroUnidade?: MembroUnidadeDetalhado) {
    this.membroUnidade = membroUnidade;
    this.papeis = this.loadPapeis(membroUnidade?.papelMembro);
  }

  get maiorPermissao(): Papel {
    for (let papel of listaPapeis)
      if (this.papeis[papel])
        return papel
    
    return Papel.UsuarioComum
  }

  private loadPapeis(papelMembro?: PapelMembro): Papeis {
    const papeis: Papeis = {
      [Papel.UsuarioComum]: false,
      [Papel.Nivel1]: false,
      [Papel.Nivel2]: false,
      [Papel.Administrador]: false,
    }

    let papelUsuarioLogado = papelMembro === undefined 
      ? Papel.UsuarioComum
      : this.descobrirPapel(papelMembro);

    PAPEIS_MEMBROS_ACUMULATIVO[papelUsuarioLogado]?.forEach(papel => {
      papeis[papel] = true;
    });

    return papeis
  }

  private descobrirPapel(papelMembro: PapelMembro): Papel {
    if (papelMembro.id === 1) {
      return Papel.Nivel1
    } else if (papelMembro.id === 2) {
      return Papel.Nivel2
    } else if (papelMembro.id === 3) {
      return Papel.Administrador
    } else {
      return Papel.UsuarioComum
    }
  }
}
